"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var _constants = require("settings-ui-sdk/SiteSettings/constants");

var _actions = require("settings-ui-sdk/SiteSettings/actions");

var _routeSelectors = require("../selectors/routeSelectors");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _SiteSettings = _interopRequireDefault(require("settings-ui-sdk/SiteSettings/SiteSettings"));

var _StagedObject = _interopRequireDefault(require("redux-less/StagedObject"));

var _PropertyTypes = _interopRequireDefault(require("redux-less/constants/PropertyTypes"));

var _getAllDomainsOrDomainNameFromURL = _interopRequireDefault(require("../utils/getAllDomainsOrDomainNameFromURL"));

var properties = [{
  type: _PropertyTypes.default.SIMPLE,
  key: _constants.ALL_DOMAINS_OR_DOMAIN_NAME,
  defaultValue: ''
}, _constants.MEMBERSHIP_COMPANY_NAME, _constants.MEMBERSHIP_WEBSITE_ADMIN, _constants.MEMBERSHIP_REGISTRATION_REDIRECT, _constants.MEMBERSHIP_LOGIN_REDIRECT, _constants.MEMBERSHIP_LOGOUT_REDIRECT, _constants.MEMBERSHIP_REGISTRATION_TEMPLATE_ID, _constants.MEMBERSHIP_LOGIN_TEMPLATE_ID, _constants.MEMBERSHIP_PASSWORD_RESET_REQUEST_TEMPLATE_ID, _constants.MEMBERSHIP_PASSWORD_RESET_TEMPLATE_ID, _constants.MEMBERSHIP_ACCESS_DENIED_TEMPLATE_ID, _constants.MEMBERSHIP_LOGOUT_TEMPLATE_ID, _constants.MEMBERSHIP_REGISTRATION_EMAIL_TEMPLATE_ID, _constants.MEMBERSHIP_PASSWORD_RESET_EMAIL_TEMPLATE_ID, _constants.MEMBERSHIP_PASSWORD_SAVED_EMAIL_TEMPLATE_ID];
var UpdateSiteSettings = new _StagedObject.default({
  stagedSelector: function stagedSelector(state) {
    return state.modules[_UrlPathParams.CONTENT_MEMBERSHIP].staging.updateSiteSettings;
  },
  domainSelector: _routeSelectors.getSiteSettingsFromRoute,
  requestSuccessActionType: _actions.FetchSiteSettingsActionTypes.SUCCESS,
  requestSuccessDataSelector: function requestSuccessDataSelector(payload) {
    var allDomainsOrDomainName = (0, _getAllDomainsOrDomainNameFromURL.default)(window.location.href);

    if (allDomainsOrDomainName && allDomainsOrDomainName !== _UrlPathParams.ALL_DOMAINS) {
      var overrideByDomain = payload.data[_constants.BODY_OVERRIDE_BY_DOMAIN][allDomainsOrDomainName];

      if (overrideByDomain) {
        var domainSiteSettings = (0, _immutable.fromJS)(payload.data).merge(overrideByDomain).toJS();
        return new _SiteSettings.default((0, _extends2.default)({
          allDomainsOrDomainName: allDomainsOrDomainName
        }, domainSiteSettings));
      }
    }

    return new _SiteSettings.default((0, _extends2.default)({
      ALL_DOMAINS: _UrlPathParams.ALL_DOMAINS
    }, payload.data));
  },
  namespace: _UrlPathParams.CONTENT_MEMBERSHIP,
  objectType: _UrlPathParams.CONTENT_MEMBERSHIP + "/SiteSettings",
  properties: properties
});
var _default = UpdateSiteSettings;
exports.default = _default;
module.exports = exports.default;